import React from "react"
import styled from "@emotion/styled"

import theme from "../../theme.js"

const ErrorText = ({ text, footer }) => {
  const ErrorTextWrapper = styled.div`
    p {
      color: rgb(224, 43, 39);
      font-family: ${theme.font.book} !important;
      font-size: 12px;
      margin-bottom: 0;
      padding-left: ${footer ? "24px" : "0"};
    }
  `
  return (
    <ErrorTextWrapper>
      <p>{text}</p>
    </ErrorTextWrapper>
  )
}

export default ErrorText
